import { Route, Routes } from 'react-router-dom';
import './App.css';
import './assets/css/fonts/fontstyles.css';
import Home from './screens/home/Home';
import Therapists from './subscreen/doctor/docbuttons/DoctorPage';
import About from './screens/homesections/about/About';
import Blog from './screens/homesections/blog/Blog';  
import BlogDetail from './screens/homesections/blog/BlogPost';
import ConfirmationPage from './subscreen/patient/confirmbooking/ConfirmBooking';
import PaymentReturn from './subscreen/patient/PaymentReturn';

                    /////// Therapist pages ////////////////

import Terms from './screens/homesections/terms/Terms';
import Privacy from './screens/homesections/privacy/Privacy';
             /////// Therapist pages ////////////////
import ProtectedDoctorRoute from './subscreen/doctor/doctorpages/ProtectedDoctorRoute';
import Authentication from './subscreen/doctor/doctorpages/Kyc';
import ScheduleManagement from './subscreen/doctor/doctorpages/ScheduleManagement'; 
import Appointments from './subscreen/doctor/doctorpages/Appointments';
import History from './subscreen/doctor/doctorpages/History';
import DisputeViewResponse from './subscreen/doctor/doctorpages/DisputeViewResponse';
import DoctorSettings from './subscreen/doctor/doctorpages/DoctorSettings';
import Prescriptions from './subscreen/doctor/doctorpages/Prescriptions';
import ProfileManagement from './subscreen/doctor/doctorpages/ProfileManagement';
import Wallet from './subscreen/doctor/doctorpages/Wallet';
import DoctorDashboard from './subscreen/doctor/doctorpages/DoctorDashboard';
import DoctorMessages from './subscreen/doctor/doctorpages/DoctorMessages';
import DoctorNotifications from './subscreen/doctor/doctorpages/DoctorNotifications';
import HelpSupport from './subscreen/doctor/doctorpages/HelpSupport';
import TherapistAnalytics from './subscreen/doctor/doctorpages/TherapistAnalytics';

                       /////////Admin Pages///////////////

import { Navigate } from "react-router-dom";
import AdminLogin from './subscreen/admin/adminauth/AdminLogin';
import ProtectedAdminRoute from './subscreen/admin/adminauth/ProtectedAdminRoute';
import AdminLayout from './subscreen/admin/layout/adminlayout/AdminLayout';
import Dashboard from './subscreen/admin/pages/Dashboard';
import AppointmentsManagement from "./subscreen/admin/pages/AppointmentsManagement";
import Notifications from "./subscreen/admin/pages/Notifications";
import EarningsCommissions from "./subscreen/admin/pages/EarningsCommissions";
import Patients from "./subscreen/admin/pages/Patients";
import Settings from "./subscreen/admin/pages/Settings";
import SupportTickets from "./subscreen/admin/pages/SupportTickets";
import TherapistManagement from "./subscreen/admin/pages/TherapistManagement";
import AdminProfile from './subscreen/admin/pages/profile';
import BlogManagement from './subscreen/admin/pages/BlogManagement';

                   //////  Patient Pages ///////////////

import PatientMasterLayout from './subscreen/patient/patientlayouts/PatientMasterlayout';
import PatientDashboard from './subscreen/patient/patientlayouts/layoutpages/Dashboard';   // 🆕 NEW
import MyAppointment from './subscreen/patient/patientlayouts/layoutpages/MyAppointment';
import PatientProfile from './subscreen/patient/patientlayouts/layoutpages/PatientProfile';
import Feedback from './subscreen/patient/patientlayouts/layoutpages/Feedback';
import MyNotifications from './subscreen/patient/patientlayouts/layoutpages/MyNotifications';
import Payment from './subscreen/patient/patientlayouts/layoutpages/Payment';
import MySettings from './subscreen/patient/patientlayouts/layoutpages/MySettings';
import SupportTicket from './subscreen/patient/patientlayouts/layoutpages/SupportTickets';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path='/doctors' element={<Therapists />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogpost" element={<BlogDetail />} />
        <Route path="/confirmbooking" element={<ConfirmationPage />} />
        <Route path="/payment/return" element={<PaymentReturn />} />

         <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
        {/* 🔁 CHANGED: Patient Dashboard — ab NESTED routes hain, Outlet ke through render hongi */}
        <Route path="/patientdashboard" element={<PatientMasterLayout />}>
          <Route index element={<PatientDashboard />} />               {/* 🆕 default/overview page */}
          <Route path="myappointments" element={<MyAppointment />} />
         <Route path="profile" element={<PatientProfile />} />   {/* 👈 ye change karo */}
          <Route path="feedback" element={<Feedback />} />
          <Route path="mynotifications" element={<MyNotifications />} />
          <Route path="payment" element={<Payment />} />
          <Route path="mysettings" element={<MySettings />} />
          <Route path="supportticket" element={<SupportTicket />} />
        </Route>

                         {/* Doctor ky dashboard ky liye routes  */}

<Route path="/doctor" element={<ProtectedDoctorRoute><DoctorDashboard /></ProtectedDoctorRoute>} />   
     <Route path="/doctor/Kyc" element={<ProtectedDoctorRoute><Authentication/></ProtectedDoctorRoute>} />
        <Route path="/doctor/appointments" element={<ProtectedDoctorRoute><Appointments /></ProtectedDoctorRoute>} />
        <Route path="/doctor/schedulemanagement" element={<ProtectedDoctorRoute><ScheduleManagement /></ProtectedDoctorRoute>} /> 
        <Route path="/doctor/wallet" element={<ProtectedDoctorRoute><Wallet /></ProtectedDoctorRoute>} />
        <Route path="/doctor/profile" element={<ProtectedDoctorRoute><ProfileManagement /></ProtectedDoctorRoute>} />
        <Route path="/doctor/settings" element={<ProtectedDoctorRoute><DoctorSettings /></ProtectedDoctorRoute>} />
        <Route path="/doctor/history" element={<ProtectedDoctorRoute><History /></ProtectedDoctorRoute>} />
        <Route path="/doctor/prescriptions" element={<ProtectedDoctorRoute><Prescriptions /></ProtectedDoctorRoute>} />
        <Route path="/doctor/dispute" element={<ProtectedDoctorRoute><DisputeViewResponse /></ProtectedDoctorRoute>} />
        <Route path="/doctor/helpsupport" element={<ProtectedDoctorRoute><HelpSupport /></ProtectedDoctorRoute>} />
        <Route path="/doctor/notifications" element={<ProtectedDoctorRoute><DoctorNotifications /></ProtectedDoctorRoute>} />
        <Route path="/doctor/doctormessages" element={<ProtectedDoctorRoute><DoctorMessages /></ProtectedDoctorRoute>} />
        <Route path="/doctor/therapistanalytics" element={<ProtectedDoctorRoute>< TherapistAnalytics /></ProtectedDoctorRoute>} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />


        <Route path="/admin/*" element={
          <ProtectedAdminRoute>
            <AdminLayout>
              <Routes>
                <Route path="profile" element={<AdminProfile />} />
                <Route path="/" element={<Navigate to="profile" />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="/" element={<Navigate to="dashboard" />} />
                <Route path="patients" element={<Patients />} />
                <Route path="/" element={<Navigate to="patients" />} />
                <Route path="therapists" element={<TherapistManagement />} />
                <Route path="/" element={<Navigate to="therapists" />} />
                <Route path="appointments" element={<AppointmentsManagement />} />
                <Route path="/" element={<Navigate to="appointments" />} />
                <Route path="tickets" element={<SupportTickets />} />
                <Route path="/" element={<Navigate to="tickets" />} />
                <Route path="earnings" element={<EarningsCommissions />} /> 
                <Route path="/" element={<Navigate to="earnings" />} />
                <Route path="settings" element={<Settings />} />
                <Route path="/" element={<Navigate to="settings" />} />
                <Route path="blog" element={<BlogManagement />} />
                <Route path="/" element={<Navigate to="blog" />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="/" element={<Navigate to="notifications" />} />
              </Routes>
            </AdminLayout>
          </ProtectedAdminRoute>
        } />
      </Routes>
    </>
  );
}
export default App;